<template>
    <div class="elder-extend">
        <mt-header fixed title="延伸信息编辑">
            <router-link :to="'/elder/'+id" slot="left">
                <mt-button icon="back">返回</mt-button>
            </router-link>
        </mt-header>
        <div class="elder-form">
            <mint-select selectLabel="文化程度" selectPatch="education" :selectValue="education" :slots="educationSlots" @changeValue="changeValue"></mint-select>

            <mt-checklist title="职业" v-model="career" :options="careerOptions"></mt-checklist>
            <mt-checklist title="主要经济来源" v-model="economy_source" :options="economySourceOptions"></mt-checklist>

            <mt-radio title="是否退休" v-model="is_retired" :options="isRetiredOptions"></mt-radio>
            <mt-field label="原工作单位" placeholder="请输入原工作单位" v-model="retire_company"></mt-field>

            <mt-field label="身高" placeholder="CM" v-model="tall"></mt-field>
            <mt-field label="体重" placeholder="KG" v-model="weight"></mt-field>
            <mt-field label="腰围" placeholder="CM" v-model="waistline"></mt-field>

            <mt-radio title="性格" v-model="character" :options="characterOptions"></mt-radio>

            <mt-field label="特长" placeholder="请输入特长" v-model="skill"></mt-field>

            <mt-checklist title="爱好" v-model="hobbits" :options="hobbitsOptions"></mt-checklist>
            <div class="new-form-button">
                <mt-button size="large" type="primary" @click="updateElder">提交</mt-button>
            </div>
        </div>
    </div>
</template>
<script>
    import mintSelect from '../../components/mintSelect.vue'

    export default{
        components: {
            'mint-select':mintSelect
        },

        data(){
            return {
                openid:JSON.parse(window.localStorage.getItem('UserInfo')).openid,
                id:this.$route.params.id,

                education:'',
                educationSlots: [
                    {
                        values: [''],
                        className: 'slot1',
                        textAlign: 'center'
                    }
                ],

                career:[],
                careerOptions : [],

                economy_source:[],
                economySourceOptions:[],

                is_retired:"0",
                isRetiredOptions:[
                    {
                        label:'否',
                        value:"0",
                    },{
                        label:'是',
                        value:"1"
                    }
                ],

                tall:'',
                weight:'',
                waistline:'',

                retire_company:'',

                character:"外向",
                characterOptions:[
                    {
                        label:'外向',
                        value:"外向",
                    },{
                        label:'内向',
                        value:"内向"
                    }
                ],

                skill:'',

                hobbits:[],
                hobbitsOptions:[],

            }
        },

        methods:{

            //mini-select
            changeValue(value){
                let props = value[0];
                this[props] = value[1];
            },

            updateElder(){

                this.$indicator.open('加载中');

                this.$axios.post("/elder/extend", {openid:this.openid,elder:this.id,education:this.education,career:this.career,economy_source:this.economy_source,is_retired:this.is_retired,retire_company:this.retire_company,tall:this.tall,weight:this.weight,waistline:this.waistline,character:this.character,skill:this.skill,hobbits:this.hobbits})
                    .then(data => {

                        this.$indicator.close();

                        if (data.data.code === 'OK') {
                            this.$toast('修改成功!');
                        } else {
                            this.$toast(data.data.message);
                        }
                    });
            },


        },

        created(){
            this.$axios.get('/elder/extend?openid='+this.openid+'&elder='+this.id)
                .then(data => {

                    if (data.data.code === 'OK') {

                        let elder_info = data.data.data;
                        this.tall = elder_info.tall;
                        this.weight = elder_info.weight;
                        this.waistline = elder_info.waistline;
                        this.skill = elder_info.skill;
                        this.is_retired = elder_info.is_retired.toString();
                        this.retire_company = elder_info.retire_company;
                        this.character = elder_info.character;

                        this.educationSlots[0].values = data.data.options.education;
                        this.education = elder_info.education;

                        var career_array = Array();
                        for(let i=0;i<data.data.options.career.length;i++){
                            career_array[i] = { label:data.data.options.career[i],value:data.data.options.career[i]};
                        }
                        this.careerOptions = career_array;
                        this.career = elder_info.career===null?[]:elder_info.career.split(',');

                        var economy_source_array = Array();
                        for(let i=0;i<data.data.options.economy_source.length;i++){
                            economy_source_array[i] = { label:data.data.options.economy_source[i],value:data.data.options.economy_source[i]};
                        }
                        this.economySourceOptions = economy_source_array;
                        this.economy_source = elder_info.economy_source===null?[]:elder_info.economy_source.split(',');

                        var hobbits_array = Array();
                        for(let i=0;i<data.data.options.hobbits.length;i++){
                            hobbits_array[i] = { label:data.data.options.hobbits[i],value:data.data.options.hobbits[i]};
                        }
                        this.hobbitsOptions = hobbits_array;
                        this.hobbits = elder_info.hobbits===null?[]:elder_info.hobbits.split(',');

                    } else {
                        this.$toast(data.data.message);
                    }
                });
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/elder/extend.vue